export const DEFAULT_SCREEN_WIDTH = {
  mobileWidth: 430,
  tabletWidth: 768,
  get getWidth() {
    return this.mobileWidth;
  },
  /**
   * @param {number} value
   */
  set setWidth(value) {
    this.mobileWidth = value;
  },
};
